/* eslint-disable react/destructuring-assignment */

import CodeBlock, { CodeBlockProps } from "./CodeBlock";
import RoleBlock, { RoleBlockProps } from "./RoleBlock";

export type ClientBlockProps = CodeBlockProps &
  RoleBlockProps & {
    children: React.ReactNode;
  };

const ClientBlock = (props: ClientBlockProps) => {
  const { roles, blockInForeignContext, children, ...rest } = props;

  return (
    <RoleBlock roles={roles} blockInForeignContext={blockInForeignContext}>
      <CodeBlock {...rest}>{children}</CodeBlock>
    </RoleBlock>
  );
};

export default ClientBlock;
